module.exports = __webpack_public_path__ + "img/icon_shares_add@3x.c24ca9a0.png";